import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row text-start" }
const _hoisted_2 = { class: "product-item card col-md-12 faulty" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row col-md-12" }
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.productData && _ctx.productData.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("div", null, " Error occured when parsing data for the following products: ", -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productData, (product, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(product.customerProductNumber) + ", " + _toDisplayString(product.customerProductName), 1))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}